import { schoolDistricts } from "./schoolDistrictsData";
import { useParams } from "react-router-dom";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";

const SchoolDistrict = () => {
  const { districtSlug } = useParams();
  const district = schoolDistricts[districtSlug];

  if (!district) {
    return <div>District not found</div>;
  }

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-blue-50 to-white">
      {/* Landing Section */}
      <LandingSection
        data={{
          imageName: "school.webp",
          title: `Schools in ${district.districtName}`,
          visible: true,
        }}
      />

      {/* Main Content */}
      <div className="mx-auto py-12 w-full">
        {/* Table */}
        {/* <div className="flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
            <div className="overflow-x-auto max-h-[1000px]">
              <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
                <thead className="sticky top-0 z-10">
                  <tr>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[35%]">
                      School Name
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[35%]">
                      Number of Students
                    </th>
                    <th className="px-6 py-4 text-center text-[20px] font-bold text-blue-800 tracking-wider w-[30%]">
                      Grades
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white">
                  {district.schools.map((school, index) => (
                    <tr
                      key={index}
                      className="hover:bg-blue-50 transition-colors"
                    >
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="font-bold text-sm text-blue-900">
                          {school.schoolName}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {school.numberOfStudents}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-center font-bold text-blue-900">
                          {school.grades}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div> */}

        <div className="flex items-center justify-center my-12">
          <div className="bg-gray-300 z-10 rounded-xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden w-[95%]">
            <div className="overflow-x-auto max-h-[800px]">
              <table className="table-auto border-collapse border bg-white border-gray-300 w-full">
                <thead className="sticky top-0 z-10">
                  <tr>
                    <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center">
                      School Name
                    </th>
                    <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center">
                      Number of Students
                    </th>
                    <th className="border border-gray-300 bg-gray-300 px-4 py-2 text-center">
                      Grade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {district.schools.map((school, index) => (
                    <tr key={school.sn} className="hover:bg-gray-100">
                      <td className="border border-gray-300 px-4 py-2 text-center font-bold text-blue-900">
                        {school.schoolName}
                      </td>

                      <td className="border border-gray-300 px-4 py-2 text-center font-bold text-blue-900">
                        {school.numberOfStudents}
                      </td>
                      <td className="border border-gray-300 px-4 py-2 font-bold text-blue-900">
                        {school.grades}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SchoolDistrict;
